module.exports = __webpack_public_path__ + "static/m_how_it_works_fun_art-929240593f4cbe7872f1d6a297f4aaca.png";